import { compareSequence } from "./realtime-recovery.js";

/** 返回false时才走旧消息表兼容；无权、失败和损坏游标不能静默退回旧读取。 */
export async function catchUpSequence({ getCurrent, sessionId, getSequenceMessages, markSpecific, canMarkRead, currentUserId, onMore, onRead }) {
  for (let budget = 0; budget < 8; budget++) {
    const current = getCurrent(); if (!current || String(current.sessionId) !== String(sessionId)) return true;
    const epoch = current.syncEpoch;
    const after = current.stableSequenceCursor || "0";
    let response;
    try { response = await getSequenceMessages(sessionId, { afterSequence: after }); }
    catch (error) { if (error.response?.status === 404) return false; throw error; }
    const target = getCurrent(); if (!target || String(target.sessionId) !== String(sessionId) || target.syncEpoch !== epoch) return true;
    if (Number(response?.code) === 404) return false;
    if (response?.errorCode === "CHAT_CURSOR_RESET_REQUIRED" && after !== "0") { target.stableSequenceCursor = "0"; continue; }
    if (Number(response?.code) !== 200) throw new Error(response?.msg || "消息同步失败");
    const page = response.data;
    if (page.mode !== "SEQUENCE") { target.stableSequenceCursor = null; return false; }
    if (target.sequenceEpoch !== page.epoch) { target.messages = target.messages.filter(m => m.sending && !m.id); target.lastReadSequence = null; }
    target.sequenceEpoch = page.epoch;
    if (compareSequence(page.throughSequence, after) < 0 || page.hasMore && compareSequence(page.throughSequence, after) === 0) throw new Error("消息序号分页未推进");
    const existing = new Map(target.messages.filter(m => m.id).map(m => [String(m.id), m]));
    for (const item of page.items) {
      const previous = existing.get(String(item.id));
      if (previous) previous.messageSequence = item.messageSequence;
      else { const message = { id: item.id, messageSequence: item.messageSequence, content: item.content || "", isSelf: String(item.senderUserId) === String(currentUserId), time: item.sendTime || item.createTime }; target.messages.push(message); existing.set(String(item.id), message); }
    }
    target.messages.sort((a, b) => a.messageSequence && b.messageSequence ? compareSequence(a.messageSequence, b.messageSequence) : a.id && b.id ? compareSequence(a.id, b.id) : a.id ? -1 : b.id ? 1 : 0);
    const readItems = page.items.length ? page.items : target.messages.slice(-100).filter(m => m.id);
    if (readItems.length && markSpecific && canMarkRead() && target.lastReadSequence !== page.throughSequence) {
      const result = await markSpecific(sessionId, readItems.map(m => String(m.id)));
      if (Number(result?.code) !== 200) throw new Error("消息已读确认失败");
      onRead();
      target.lastReadSequence = page.throughSequence;
    }
    if (getCurrent() !== target || target.syncEpoch !== epoch) return true;
    target.stableSequenceCursor = page.throughSequence;
    if (!page.hasMore) return true;
  }
  onMore(); return true;
}
